import * as SettingsActions from "./settingsActions";

export default SettingsActions;



// WEBPACK FOOTER //
// ./src/actions/SettingsActions/index.js